import Intercom, { show } from "@intercom/messenger-js-sdk";
import { Box, Button, CircularProgress, Typography } from "@mui/joy";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useGetMissionMapQuery } from "../redux/missionMap";
import {
  setSelectedInteractor,
  setSelectedToken,
} from "../redux/rhapsodyReducer";
import { PollInvite } from "../templates/pollInvite";
import { ProjectInvite } from "../templates/projectInvite";
import { ProjectsInvite } from "./projects";

/**
 *
 * @returns {ReactElement} A happy coding page!
 */
export function AnswerRoute() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const interactorID = searchParams.get("interactorID");
  const version = searchParams.get("version");
  const dispatch = useDispatch();
  const { isLoading, isError, data, error } = useGetMissionMapQuery(
    token ?? "",
    {
      skip: !token,
    },
  );

  useEffect(() => {
    // Single-mission tokens (assignments + cattle calls) drive the answers
    // slice by selectedToken — the reducers fall back to the URL token but
    // the selectors don't, so without this the Accept/Decline confirm bar
    // never shows.
    if (token && (token[0] === "A" || token[0] === "C")) {
      dispatch(setSelectedToken(token));
    }
  }, [token]);

  useEffect(() => {
    if (interactorID && data) {
      dispatch(
        setSelectedInteractor(
          data.Interactors?.find((i) => `${i.ID}` === interactorID),
        ),
      );
    }

    if (data) {
      Intercom({
        app_id: "arj556zn",
        hide_default_launcher: true,
        user_id: data.MusicianEmail,
        // user_id: me.uuid, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
        name: data.MusicianName, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
        email: data.MusicianEmail, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
        // created_at: me.createdAt, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
      });
    }
  }, [interactorID, data]);

  useEffect(() => {
    if (isError) {
      Intercom({
        app_id: "arj556zn",
        hide_default_launcher: true,
      });
    }
  }, [isError]);

  useEffect(() => {
    if (!token) {
      window.location.replace("https://rhapsody.la/");
    }
  }, [token]);

  if (isLoading)
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
        }}
      >
        <CircularProgress />
      </Box>
    );

  if (isError) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          background: "#021B33",
        }}
      >
        <div className="no-signal"></div>
        <div className="frame">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            gap: 4,
            flexDirection: "column",
          }}
        >
          <img
            style={{ height: 80 }}
            src="https://storage.googleapis.com/wid-rhapsody/images/logo_main-white.png"
          />
          <Box>
            <Typography sx={{ color: "white", fontWeight: 800 }} level="h4">
              Invite Not Found
            </Typography>
            <Typography sx={{ color: "white" }}>
              Chat with us if you think it is a bug.
            </Typography>
          </Box>
          <Button onClick={show}>Chat with Support</Button>
        </Box>
      </Box>
    );
  }

  if (token && token[0] === "P") {
    return <PollInvite token={token} />;
  }

  if ((token && token[0] === "G") || version === "4") {
    return <ProjectsInvite />;
  }

  return <ProjectInvite token={token ?? ""} />;
}
